module.exports = __webpack_public_path__ + "img/T4-D-xs_24.7fbf7743.png";